<template>
  <div>
    <div class="nav-pc">
        <div class="title clear-float">
            个人中心
            <span class="text-btn float-r" @click="logOut">退出</span>
        </div>
    </div>
    <div class="inviteCenter2">
      <label class="title2">用户信息</label>
      <div class="centerIcon">
        <div class="point" @click="jumpTo('volunteerApply')">
          <img src="@/static/img/person_icon.png" />
          <label>报名简历</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { volunteer } from "@/api/volunteer.js";

export default {
  data() {
    return {
      detailForm: {},
    };
  },
  computed: {},
  created() {
    if (!this.$cookies.isKey("token")) {
      this.logOut();
    } else {
        this.getInfo();
    }
  },
  methods: {
    getInfo() {
      volunteer.getInfo({
        mainId: this.$session.get("cmm").mainId,
        mobile: this.$session.get("mobile")
      }).then(res => {
        if(res && res.code === 200) {
          this.$session.set("userInfo", res.data);
        }
      }).catch(() => {
       this.logOut();
      })
    },
    jumpTo(name) {
      this.$router.push({
        name: name
      });
    },
    logOut() {
      this.$router.push("/volunteer/login");
    }
  }
};
</script>

<style src="../../static/css/regist.css" scoped></style>
<style src="../../static/css/infoCommon.css" scoped></style>
